
import { computed, defineComponent, nextTick, onMounted, ref, watch } from 'vue'
import TariffRadioButton from './TariffRadioButton.vue'
import { useBillingStore } from '../../../../store/stores/billing'
import { useProject } from '../../../../hooks/useProject'
import useRouter from '@root/src/hooks/useRouter'
import {
    useTariffTrialRestrictions,
    isTrialAllowedTariff,
    TRIAL_DEFAULT_TARIFF_ID,
} from '@/hooks/useTariffTrialRestrictions'
export default defineComponent({
    components: { TariffRadioButton },
    props: {},
    setup(props, { emit }) {
        const billingStore = useBillingStore()
        const { isTrialRestricted } = useTariffTrialRestrictions()
        const tariffOrder: Record<string, number> = {
            tariff1: 1,
            tariff2: 2,
            tariff3: 3,
        }
        const sortedTariffs = computed(() => {
            const sorted = [...(billingStore.tariffs || [])].sort((a, b) => {
                const left = tariffOrder[a.id] ?? Number.MAX_SAFE_INTEGER
                const right = tariffOrder[b.id] ?? Number.MAX_SAFE_INTEGER
                return left - right
            })
            // На пробном тарифе показываем только доступные тарифы (Умный бот и tariff3), кроме суперпользователя.
            return isTrialRestricted.value ? sorted.filter(isTrialAllowedTariff) : sorted
        })
        const { project } = useProject()
        const currentTariff = computed(() => billingStore.getCurrentTariff(project.value.id))
        const selectTariff = (tariffId: string) => {
            billingStore.selectedTariffId = tariffId
        }
        // На пробном тарифе выбираем реальный видимый тариф по его id (с учётом кастомных/переименованных
        // тарифов): предпочитаем «Умный бот» (базовый tariff2), иначе — первый доступный из списка.
        const resolveRestrictedDefaultTariffId = (): string | null => {
            const visible = sortedTariffs.value
            if (!visible.length) return null
            const preferred = visible.find(
                tariff => (tariff.baseTariffId ?? tariff.id) === TRIAL_DEFAULT_TARIFF_ID
            )
            return (preferred ?? visible[0]).id
        }
        const { router }= useRouter()
        const defaultSelected = router.currentRoute.query.default
        onMounted(() => {
            // На пробном тарифе по умолчанию выбираем «Умный бот», прочие пресеты (текущий тариф, ?default) игнорируем.
            if (isTrialRestricted.value) {
                const restrictedId = resolveRestrictedDefaultTariffId()
                if (restrictedId) billingStore.selectedTariffId = restrictedId
                return
            }
            if (currentTariff.value) {
                billingStore.selectedTariffId = currentTariff.value.integrationId
            }
            if (defaultSelected) {
                billingStore.selectedTariffId = defaultSelected as string
            }

        })
        watch(currentTariff, ()=>{
            if (isTrialRestricted.value) {
                const restrictedId = resolveRestrictedDefaultTariffId()
                if (restrictedId) selectTariff(restrictedId)
                return
            }
            if (!defaultSelected) {
                selectTariff(currentTariff.value.integrationId)
            }
        })
        return { billingStore, sortedTariffs, selectTariff }
    },
})
